import { API_URL, BRANDS } from '../../common';
import { axiosClient } from '../api';

export const getCountryNames = (brandName, lang) => {
  let langId;
  if (lang === 'ru' || lang === 'kz' || lang === 'ua') {
    langId = 1;
  } else if (lang === 'br') {
    langId = 6;
  } else if (lang === 'en') {
    langId = 2;
  } else if (lang === 'uz') {
    langId = 1091;
  }
  return axiosClient
    .get(`${API_URL}/ajax/data/country?lang_id=${langId}`)
    .then((response) => response.data.result)
    .catch((err) => console.log(`Ошибка при запросе названий стран на языке: ${err}`));
};

/**
 * Получить валюты, которые доступны/актуальны на текущем домене
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getCurrencyData = (brandName) =>
  axiosClient
    .get(`${API_URL}/ajax/account/data`)
    .then((response) => {
      try {
        const currency = response.data.result.finance_data.currency;
        let order;

        if (brandName === BRANDS.zenit) {
          order = response.data.result.finance_data.order;
          order.push(27);
        } else {
          order = Object.keys(response.data.result.finance_data.currency);
        }
        return order.map((item) => {
          if (!currency[item]) {
            return false;
          }
          const el = currency[item];
          el.label = el.full_name;
          return el;
        });
      } catch (error) {
        console.error(error);
        return false;
      }
    })
    .catch((error) => {
      console.error(error);
      return error.response;
    });

/**
 * Проверка корректности промокода
 *
 * @param {FormData} formData Получает объект FormData с промокодом
 * @returns {Promise<AxiosResponse<any>>}
 */
export const dispatchPromoCode = (formData) =>
  axiosClient({
    method: 'post',
    url: `${API_URL}/ajax/account/promo/check`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }).catch((error) => {
    console.error(error);
    return error.response;
  });

export const getCountryId = (country) =>
  typeof country === 'object' && country !== null ? country.country_id : country;

export const getCurrency = (currency) =>
  typeof currency === 'object' && currency !== null ? currency.id : currency;

/**
 * Проверка всех данных пользователя при регистрации (1й шаг)
 *
 * @param {Object} data Данные пользователя с формы регистрации
 * @returns {Promise<AxiosResponse<any>>}
 */
export const dispatchCheckPhone = (data) => {
  const exemplar = {
    phone: data.phone,
    country_id: getCountryId(data.country),
    currency: getCurrency(data.currency),
    password: data.password,
    promo_code: data.promocode,
    birthdate: data.formattedDate,
    email: data.email,
    recaptcha: data.token,
    captcha_state: 0,
    recaptcha_version: 'V3',
    recaptcha_action: 'registration',
  };
  const formData = new FormData();
  Object.keys(exemplar).forEach((key) => {
    if (key === 'phone') {
      exemplar.phone = exemplar.phone.replace(/[^+0-9]/g, '');
    }
    if (!exemplar[key] && key !== 'captcha_state') return null;
    formData.append(key, exemplar[key]);
  });

  return axiosClient({
    method: 'post',
    url: `${API_URL}/ajax/registration/check_phone`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }).catch((error) => {
    console.error(error);
    return error.response;
  });
};

// Регистрация 1й шаг - новое апи цупис
export const checkRegistration = (data) => {
  const userData = {
    phone: data.phone,
    country_id: data.country.country_id,
    currency: data.currency.id,
    password: data.password,
    promo_code: data.promocode,
    birthdate: data.formattedDate,
    email: data.email,
    recaptcha: data.token,
    captcha_state: 0,
    recaptcha_version: 'V3',
    recaptcha_action: 'registration',
  };
  const formData = new FormData();
  Object.keys(userData).forEach((key) => {
    if (key === 'phone') {
      userData.phone = userData.phone.replace(/[^+0-9]/g, '');
    }
    if (!userData[key] && key !== 'captcha_state') return null;
    formData.append(key, userData[key]);
  });

  return axiosClient({
    method: 'post',
    url: `${API_URL}/ajax/registration/register_v2`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }).catch((error) => {
    console.error(error);
    return error.response;
  });
};

// Повторная отправка кода смс
export const sendSms = () =>
  axiosClient({
    method: 'post',
    url: `${API_URL}/ajax/account/sms/send`,
  }).catch((error) => {
    console.error(error);
    return error.response;
  });

// Проверка кода смс - 2й шаг - новое апи цупис
export const checkSms = (formData) =>
  axiosClient({
    method: 'post',
    url: `${API_URL}/ajax/account/sms/check`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }).catch((error) => {
    console.error(error);
    return error.response;
  });

export const dispatchCheckEmail = (data) => {
  const exemplar = {
    phone: null,
    country_id: data.country.country_id,
    currency: data.currency.id,
    password: data.password,
    promo_code: data.promocode,
    email: data.email,
    recaptcha: data.token,
    recaptcha_version: 'V3',
    recaptcha_action: 'registration',
    captcha_state: 0,
  };

  const formData = new FormData();
  Object.keys(exemplar).forEach((key) => {
    if (!exemplar[key]) return null;
    formData.append(key, exemplar[key]);
  });

  return axiosClient({
    method: 'post',
    url: `${API_URL}/ajax/registration/register_email`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }).catch((error) => {
    console.error(error);
    return error.response;
  });
};

/**
 * Проверка кода из смс (2й шаг)
 *
 * @param {FormData} formData Получает объект FormData с промокодом
 * @returns {Promise<AxiosResponse<any>>}
 */
export const dispatchVerifyCode = (formData) =>
  axiosClient({
    method: 'post',
    url: `${API_URL}/ajax/registration/register_new`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  }).catch((error) => {
    console.error(error);
    return error.response;
  });

//TODO удалить запрос и использовать из api.js (дубликат)
export const getAccountData = () =>
  axiosClient
    .get(`${API_URL}/ajax/account/data`)
    .then((response) => response)
    .catch((error) => {
      console.error(error);
      return error.response;
    });

/**
 * Получить перечень платежек на текущем домене
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getFinanceDepositData = () =>
  axiosClient
    .get(`${API_URL}/ajax/v1/finance/deposit/data`)
    .then((response) => response)
    .catch((error) => {
      console.error(error);
      return error.response;
    });
